import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromGraphql from './form-field-option.graphql';
import * as fromActions from './form-field-option.actions';
import {map, switchMap} from 'rxjs';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';


@Injectable()
export class FormFieldOptionEffects {

  citizenGetFormFieldOptions$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetFormFieldOptions),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_FIELD_OPTIONS,
        fetchPolicy: 'network-only',
        variables: {
          fieldUniqueId: action.fieldUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching fillable form field options'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadFormFieldOptions({ formFieldOptions: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
